export const TYPE_RE_ENTRY = 1
export const TYPE_CESSATION = 0
